<template>
  <vbt-error-boundary
    :error="$attrs.error"
    :no-content="!items.length"
  >
    <vbt-table
      :headers="headers"
      :items="items"
      show-paginator
    >
      <template #orderItemId="{ item: { orderItemId } }">
        {{ orderItemId || '-' }}
      </template>
      <template #created="{ item: { created } }">
        {{ formatDate(created, { dateFormat: 'yyyy-MM-dd, hh:mm:ss.SSS a' }) }}
      </template>
    </vbt-table>
  </vbt-error-boundary>
</template>

<script>
import { mapState } from 'vuex';

import { provideThemeSettings } from '@mixins';

import { formatDate } from '@helpers';

import { namespace as LocationsNamespace } from '@store/modules/locations.types';

const headers = Object.freeze([
  { text: 'Order Item ID', value: 'orderItemId' },
  { text: 'Attribute Type', value: 'attributeType' },
  { text: 'Key', value: 'key' },
  { text: 'Value', value: 'value' },
  { text: 'Side', value: 'side' },
  { text: 'Created Date', value: 'created' },
  { text: 'Operator', value: 'operator' },
]);

export default {
  name: 'KernelOrderAttributes',
  mixins: [
    provideThemeSettings,
  ],
  props: {
    items: {
      type: Array,
      default: () => [],
    },
  },
  data: () => ({ headers }),
  computed: {
    ...mapState(LocationsNamespace, ['suffix']),
  },
  methods: {
    formatDate,
  },
};
</script>
